import { grpcClientFactory } from '../../grpcClientFactory';
// Maps the proto AccessLevel enum (ACCESS_LEVEL_NONE=0, SCOUTING=1, DEMO=2,
// FULL=3) onto the string union the UI reads. Unknown values fall back to the
// safe floor, 'none'.
function mapProtoAccessLevel(value) {
    switch (value) {
        case 3:
            return 'full';
        case 2:
            return 'demo';
        case 1:
            return 'scouting';
        default:
            return 'none';
    }
}
function mapProtoDemSourceMetadata(protoMeta) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    if (!protoMeta)
        return undefined;
    const out = {};
    if ((_a = protoMeta.hasDatasetName) === null || _a === void 0 ? void 0 : _a.call(protoMeta))
        out.datasetName = protoMeta.getDatasetName();
    if ((_b = protoMeta.hasDatasetId) === null || _b === void 0 ? void 0 : _b.call(protoMeta))
        out.datasetId = protoMeta.getDatasetId();
    if ((_c = protoMeta.hasResolutionMeters) === null || _c === void 0 ? void 0 : _c.call(protoMeta))
        out.resolutionMeters = protoMeta.getResolutionMeters();
    if ((_d = protoMeta.hasResolutionUnits) === null || _d === void 0 ? void 0 : _d.call(protoMeta))
        out.resolutionUnits = protoMeta.getResolutionUnits();
    if ((_e = protoMeta.hasAcquisitionYear) === null || _e === void 0 ? void 0 : _e.call(protoMeta))
        out.acquisitionYear = protoMeta.getAcquisitionYear();
    if ((_f = protoMeta.hasDoi) === null || _f === void 0 ? void 0 : _f.call(protoMeta))
        out.doi = protoMeta.getDoi();
    if ((_g = protoMeta.hasCatalogUrl) === null || _g === void 0 ? void 0 : _g.call(protoMeta))
        out.catalogUrl = protoMeta.getCatalogUrl();
    if ((_h = protoMeta.hasCitation) === null || _h === void 0 ? void 0 : _h.call(protoMeta))
        out.citation = protoMeta.getCitation();
    if ((_j = protoMeta.hasLicense) === null || _j === void 0 ? void 0 : _j.call(protoMeta))
        out.license = protoMeta.getLicense();
    if ((_k = protoMeta.hasAcquisitionStart) === null || _k === void 0 ? void 0 : _k.call(protoMeta))
        out.acquisitionStart = protoMeta.getAcquisitionStart();
    if ((_l = protoMeta.hasAcquisitionEnd) === null || _l === void 0 ? void 0 : _l.call(protoMeta))
        out.acquisitionEnd = protoMeta.getAcquisitionEnd();
    if ((_m = protoMeta.hasWorkunitName) === null || _m === void 0 ? void 0 : _m.call(protoMeta))
        out.workunitName = protoMeta.getWorkunitName();
    if ((_o = protoMeta.hasWorkunitId) === null || _o === void 0 ? void 0 : _o.call(protoMeta))
        out.workunitId = protoMeta.getWorkunitId();
    if ((_p = protoMeta.hasQualityLevel) === null || _p === void 0 ? void 0 : _p.call(protoMeta))
        out.qualityLevel = protoMeta.getQualityLevel();
    if ((_q = protoMeta.hasMetadataLink) === null || _q === void 0 ? void 0 : _q.call(protoMeta))
        out.metadataLink = protoMeta.getMetadataLink();
    if ((_r = protoMeta.hasProjectName) === null || _r === void 0 ? void 0 : _r.call(protoMeta))
        out.projectName = protoMeta.getProjectName();
    if ((_s = protoMeta.hasAcquisitionYearStart) === null || _s === void 0 ? void 0 : _s.call(protoMeta))
        out.acquisitionYearStart = protoMeta.getAcquisitionYearStart();
    const overlapsList = ((_t = protoMeta.getAcquisitionOverlapsList) === null || _t === void 0 ? void 0 : _t.call(protoMeta)) || [];
    if (overlapsList.length > 0) {
        out.acquisitionOverlaps = overlapsList.map((o) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            return ({
                workunitName: (_b = (_a = o.getWorkunitName) === null || _a === void 0 ? void 0 : _a.call(o)) !== null && _b !== void 0 ? _b : '',
                workunitId: (_d = (_c = o.getWorkunitId) === null || _c === void 0 ? void 0 : _c.call(o)) !== null && _d !== void 0 ? _d : 0,
                acquisitionStart: (_f = (_e = o.getAcquisitionStart) === null || _e === void 0 ? void 0 : _e.call(o)) !== null && _f !== void 0 ? _f : '',
                acquisitionEnd: (_h = (_g = o.getAcquisitionEnd) === null || _g === void 0 ? void 0 : _g.call(o)) !== null && _h !== void 0 ? _h : '',
                qualityLevel: (_k = (_j = o.getQualityLevel) === null || _j === void 0 ? void 0 : _j.call(o)) !== null && _k !== void 0 ? _k : '',
            });
        });
    }
    return Object.keys(out).length > 0 ? out : undefined;
}
function mapProtoUserProject(protoProject) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const requestedBounds = protoProject.getRequestedBoundsList().map((coord) => ({
        lat: coord.getLatitude(),
        lng: coord.getLongitude()
    }));
    const customContoursList = ((_a = protoProject.getCustomContoursList) === null || _a === void 0 ? void 0 : _a.call(protoProject)) || [];
    const customContours = customContoursList.map((cc) => ({
        unit: cc.getUnit(),
        intervalValue: cc.getIntervalValue()
    }));
    return {
        id: protoProject.getId(),
        name: protoProject.getName(),
        description: protoProject.getDescription(),
        requestedBounds,
        bufferMeters: protoProject.hasBufferMeters() ? protoProject.getBufferMeters() : undefined,
        requestedAreaAcres: protoProject.hasRequestedAreaAcres() ? protoProject.getRequestedAreaAcres() : undefined,
        bufferBounds: protoProject.hasBufferBounds() ? protoProject.getBufferBounds() : undefined,
        bufferAreaAcres: protoProject.hasBufferAreaAcres() ? protoProject.getBufferAreaAcres() : undefined,
        resultBounds: protoProject.hasResultBounds() ? protoProject.getResultBounds() : undefined,
        processingStatus: protoProject.getProcessingStatus(),
        createdAt: protoProject.getCreatedAt(),
        requestedBoundsGeojson: protoProject.hasRequestedBoundsGeojson() ? protoProject.getRequestedBoundsGeojson() : undefined,
        demStatus: protoProject.hasDemStatus() ? protoProject.getDemStatus() : undefined,
        demoExpiresAt: protoProject.hasDemoExpiresAt() ? protoProject.getDemoExpiresAt() : undefined,
        displayStatus: protoProject.getDisplayStatus(),
        accessLevel: mapProtoAccessLevel((_c = (_b = protoProject.getAccessLevel) === null || _b === void 0 ? void 0 : _b.call(protoProject)) !== null && _c !== void 0 ? _c : 0),
        hasFailedLayers: (_e = (_d = protoProject.getHasFailedLayers) === null || _d === void 0 ? void 0 : _d.call(protoProject)) !== null && _e !== void 0 ? _e : false,
        paymentStatus: protoProject.hasPaymentStatus() ? protoProject.getPaymentStatus() : undefined,
        paymentMethod: protoProject.hasPaymentMethod() ? protoProject.getPaymentMethod() : undefined,
        isOwner: protoProject.getIsOwner(),
        isDemo: (_g = (_f = protoProject.getIsDemo) === null || _f === void 0 ? void 0 : _f.call(protoProject)) !== null && _g !== void 0 ? _g : false,
        myRole: ((_h = protoProject.hasMyRole) === null || _h === void 0 ? void 0 : _h.call(protoProject)) ? protoProject.getMyRole() : undefined,
        homeAccountId: ((_j = protoProject.hasHomeAccountId) === null || _j === void 0 ? void 0 : _j.call(protoProject)) ? protoProject.getHomeAccountId() : undefined,
        standardContourUnit: ((_k = protoProject.hasStandardContourUnit) === null || _k === void 0 ? void 0 : _k.call(protoProject)) ? protoProject.getStandardContourUnit() : undefined,
        customContours: customContours.length > 0 ? customContours : undefined,
        demSourceType: ((_l = protoProject.hasDemSourceType) === null || _l === void 0 ? void 0 : _l.call(protoProject)) ? protoProject.getDemSourceType() : undefined,
        demSourceMetadata: mapProtoDemSourceMetadata(((_m = protoProject.hasDemSourceMetadata) === null || _m === void 0 ? void 0 : _m.call(protoProject)) ? protoProject.getDemSourceMetadata() : null),
        scoutingGeneratedAt: ((_o = protoProject.hasScoutingGeneratedAt) === null || _o === void 0 ? void 0 : _o.call(protoProject)) ? protoProject.getScoutingGeneratedAt() : undefined,
    };
}
class ProjectCrudService {
    createAuthenticatedClient() {
        return grpcClientFactory.createAuthenticatedUserProjectsClient({ enableCompression: true });
    }
    async createFromPolygon(request) {
        const sessionId = localStorage.getItem('landscope_session_id');
        const sessionToken = localStorage.getItem('landscope_session_token');
        if (!sessionId || !sessionToken) {
            throw new Error('User must be authenticated to create projects');
        }
        return new Promise((resolve, reject) => {
            try {
                const NewProjectFromPolygonRequest = proto.landscope.mapviewer.v1.NewProjectFromPolygonRequest;
                const grpcRequest = new NewProjectFromPolygonRequest();
                grpcRequest.setName(request.name);
                grpcRequest.setDescription(request.description);
                grpcRequest.setAreaAcres(request.areaAcres);
                grpcRequest.setBufferMeters(request.bufferDistanceMeters);
                const coordinatesList = request.coordinates.map(coord => {
                    const Coordinate = proto.landscope.mapviewer.v1.Coordinate;
                    const protoCoord = new Coordinate();
                    protoCoord.setLatitude(coord.lat);
                    protoCoord.setLongitude(coord.lng);
                    return protoCoord;
                });
                grpcRequest.setCoordinatesList(coordinatesList);
                if (request.standardContourUnit) {
                    grpcRequest.setStandardContourUnit(request.standardContourUnit);
                }
                if (request.customContours && request.customContours.length > 0) {
                    const CustomContour = proto.landscope.mapviewer.v1.CustomContour;
                    const contoursList = request.customContours.map(c => {
                        const contour = new CustomContour();
                        contour.setUnit(c.unit);
                        contour.setIntervalValue(c.intervalValue);
                        return contour;
                    });
                    grpcRequest.setCustomContoursList(contoursList);
                }
                const authenticatedClient = this.createAuthenticatedClient();
                const metadata = { 'authorization': `Bearer ${sessionId}|${sessionToken}` };
                authenticatedClient.newProjectFromPolygon(grpcRequest, metadata, (err, response) => {
                    var _a, _b;
                    if (err) {
                        console.error('ProjectCrudService: NewProjectFromPolygon error:', err);
                        reject(new Error(`Failed to create project: ${err.code} ${err.message}`));
                        return;
                    }
                    if (response) {
                        resolve({
                            success: response.getSuccess(),
                            message: response.getMessage(),
                            projectId: response.getProjectId(),
                            gateOutcome: ((_a = response.hasGateOutcome) === null || _a === void 0 ? void 0 : _a.call(response)) ? response.getGateOutcome() : undefined,
                            redirectedToProjectId: ((_b = response.hasRedirectedToProjectId) === null || _b === void 0 ? void 0 : _b.call(response)) ? response.getRedirectedToProjectId() : undefined,
                        });
                    }
                    else {
                        reject(new Error('No response received from server'));
                    }
                });
            }
            catch (error) {
                console.error('ProjectCrudService: Error creating project request:', error);
                reject(new Error(`Failed to create project request: ${error}`));
            }
        });
    }
    async list() {
        const sessionId = localStorage.getItem('landscope_session_id');
        const sessionToken = localStorage.getItem('landscope_session_token');
        if (!sessionId || !sessionToken) {
            throw new Error('User must be authenticated to list projects');
        }
        return new Promise((resolve, reject) => {
            try {
                const Empty = proto.google.protobuf.Empty;
                const grpcRequest = new Empty();
                const authenticatedClient = this.createAuthenticatedClient();
                const metadata = { 'authorization': `Bearer ${sessionId}|${sessionToken}` };
                authenticatedClient.getUserProjects(grpcRequest, metadata, (err, response) => {
                    if (err) {
                        console.error('ProjectCrudService: GetUserProjects error:', err);
                        reject(new Error(`Failed to list projects: ${err.code} ${err.message}`));
                        return;
                    }
                    if (response) {
                        const projectsList = response.getProjectsList();
                        const projects = projectsList.map((protoProject) => mapProtoUserProject(protoProject));
                        resolve({ projects });
                    }
                    else {
                        reject(new Error('No response received from server'));
                    }
                });
            }
            catch (error) {
                console.error('ProjectCrudService: Error creating list projects request:', error);
                reject(new Error(`Failed to create list projects request: ${error}`));
            }
        });
    }
    async update(projectId, name, description, standardContourUnit, customContours) {
        const client = grpcClientFactory.createAuthenticatedUserProjectsClient();
        const sessionId = localStorage.getItem('landscope_session_id');
        const sessionToken = localStorage.getItem('landscope_session_token');
        if (!sessionId || !sessionToken) {
            throw new Error('User must be authenticated to update projects');
        }
        return new Promise((resolve, reject) => {
            try {
                const request = new proto.landscope.mapviewer.v1.UpdateProjectRequest();
                request.setProjectId(projectId);
                request.setName(name);
                request.setDescription(description);
                if (standardContourUnit) {
                    request.setStandardContourUnit(standardContourUnit);
                }
                if (customContours && customContours.length > 0) {
                    const contoursList = customContours.map(cc => {
                        const contour = new proto.landscope.mapviewer.v1.CustomContour();
                        contour.setUnit(cc.unit);
                        contour.setIntervalValue(cc.intervalValue);
                        return contour;
                    });
                    request.setCustomContoursList(contoursList);
                }
                const metadata = { 'authorization': `Bearer ${sessionId}|${sessionToken}` };
                client.updateProject(request, metadata, (err, response) => {
                    if (err) {
                        console.error('Failed to update project:', err);
                        reject(new Error(err.message || 'Failed to update project'));
                        return;
                    }
                    if (!response) {
                        reject(new Error('No response received'));
                        return;
                    }
                    resolve({
                        success: response.getSuccess(),
                        message: response.getMessage()
                    });
                });
            }
            catch (error) {
                console.error('Failed to update project:', error);
                reject(new Error(error.message || 'Failed to update project'));
            }
        });
    }
    async updateDataSourceMetadata(projectId, metadata) {
        const client = grpcClientFactory.createAuthenticatedUserProjectsClient();
        const sessionId = localStorage.getItem('landscope_session_id');
        const sessionToken = localStorage.getItem('landscope_session_token');
        if (!sessionId || !sessionToken) {
            throw new Error('User must be authenticated to update data source metadata');
        }
        return new Promise((resolve, reject) => {
            try {
                const request = new proto.landscope.mapviewer.v1.UpdateProjectDataSourceMetadataRequest();
                request.setProjectId(projectId);
                const protoMeta = new proto.landscope.mapviewer.v1.DemSourceMetadata();
                if (metadata.datasetName !== undefined)
                    protoMeta.setDatasetName(metadata.datasetName);
                if (metadata.datasetId !== undefined)
                    protoMeta.setDatasetId(metadata.datasetId);
                if (metadata.resolutionMeters !== undefined)
                    protoMeta.setResolutionMeters(metadata.resolutionMeters);
                if (metadata.resolutionUnits !== undefined)
                    protoMeta.setResolutionUnits(metadata.resolutionUnits);
                if (metadata.acquisitionYear !== undefined)
                    protoMeta.setAcquisitionYear(metadata.acquisitionYear);
                if (metadata.doi !== undefined)
                    protoMeta.setDoi(metadata.doi);
                if (metadata.catalogUrl !== undefined)
                    protoMeta.setCatalogUrl(metadata.catalogUrl);
                if (metadata.citation !== undefined)
                    protoMeta.setCitation(metadata.citation);
                if (metadata.license !== undefined)
                    protoMeta.setLicense(metadata.license);
                request.setMetadata(protoMeta);
                const metadataHeaders = { 'authorization': `Bearer ${sessionId}|${sessionToken}` };
                client.updateProjectDataSourceMetadata(request, metadataHeaders, (err, response) => {
                    var _a;
                    if (err) {
                        console.error('Failed to update data source metadata:', err);
                        reject(new Error(err.message || 'Failed to update data source metadata'));
                        return;
                    }
                    if (!response) {
                        reject(new Error('No response received'));
                        return;
                    }
                    const protoProject = ((_a = response.hasProject) === null || _a === void 0 ? void 0 : _a.call(response)) ? response.getProject() : null;
                    resolve({
                        success: response.getSuccess(),
                        message: response.getMessage(),
                        project: protoProject ? mapProtoUserProject(protoProject) : undefined,
                    });
                });
            }
            catch (error) {
                console.error('Failed to update data source metadata:', error);
                reject(new Error(error.message || 'Failed to update data source metadata'));
            }
        });
    }
    async remove(projectId) {
        const client = grpcClientFactory.createAuthenticatedUserProjectsClient();
        const sessionId = localStorage.getItem('landscope_session_id');
        const sessionToken = localStorage.getItem('landscope_session_token');
        if (!sessionId || !sessionToken) {
            throw new Error('User must be authenticated to remove projects');
        }
        return new Promise((resolve, reject) => {
            try {
                const request = new proto.landscope.mapviewer.v1.RemoveProjectRequest();
                request.setProjectId(projectId);
                const metadata = { 'authorization': `Bearer ${sessionId}|${sessionToken}` };
                client.removeProject(request, metadata, (err, response) => {
                    if (err) {
                        console.error('Failed to remove project:', err);
                        reject(new Error(err.message || 'Failed to remove project'));
                        return;
                    }
                    if (!response) {
                        reject(new Error('No response received'));
                        return;
                    }
                    resolve({
                        success: response.getSuccess(),
                        message: response.getMessage()
                    });
                });
            }
            catch (error) {
                console.error('Failed to remove project:', error);
                reject(new Error(error.message || 'Failed to remove project'));
            }
        });
    }
}
export const projectCrud = new ProjectCrudService();
